import React, {Component} from 'react'
import TemplateSectionEditForm from "./form/edit.component.jsx"
import {AppContext} from '@lightspeed-invoicing/core-client/frontend'
import SideBar from '../../common/layout/sidebar.component.jsx'
import {Redirect} from "react-router-dom";

class TemplateSectionEdit extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            form: '',
        }
        this.redirect = this.redirect.bind(this)
    }

    componentDidMount() {
        SideBar.activateMenu('sales-tools')
        AppContext.getApiClient().get('/documents/'+this.props.match.params.documentId+'/sections/' + this.props.match.params.sectionId).then(res => {
            this.setState({
                form: <TemplateSectionEditForm value={res} documentId={this.props.match.params.documentId} onChange={this.redirect} onClose={this.redirect} />
            })
        })

    }

    redirect() {
        this.setState({ form: <Redirect to={{ pathname: '/templates/' + this.props.match.params.documentId + '/sections/preview'}}/> })
    }

    render() {
        return (
            <div>
                {this.state.form}
            </div>
        );
    }
}

export default TemplateSectionEdit


// WEBPACK FOOTER //
// ./src/template/sections/edit.component.jsx